import * as React from 'react';

import { IExtendedWindow, RedesignedResetPasswordPage } from '@ReactComponents/RedesignedResetPasswordPage/RedesignedResetPasswordPage';

export const ResetPasswordPage: React.FC = () => {
  return (
    <RedesignedResetPasswordPage
      csrf={(window as any as IExtendedWindow).csrf}
      email={(window as any as IExtendedWindow).email}
      success={(window as any as IExtendedWindow).locals?.success}
      error={(window as any as IExtendedWindow).locals?.error}
    />
  );
};
